// import { differenceInCalendarDays, isAfter, isBefore } from "date-fns";
import { isAfter, isBefore } from "date-fns";

export function isItemForApproval(item) {
  return !item.isApproved && isAfter(item.dateExpiring, new Date());
}

export function isItemForListing(item) {
  return item.isApproved && isAfter(item.dateExpiring, new Date());
}

export function isItemExpired(item) {
  return isBefore(item.dateExpiring, new Date());
}

// differenceInCalendarDays
